import { createFileRoute } from '@tanstack/react-router'
import { useState, useRef } from 'react'
import { faClock, faCheckCircle } from '@fortawesome/pro-solid-svg-icons'
import SimpleModalDialog from '../../components/SimpleModalDialog'
import { ExampleBodyComponentWithButtonHandler } from '../../components/debug/ExampleBodyComponentWithButtonHandler'
import type { BodyComponentHandle } from '../../components/SimpleModalDialog'

export const Route = createFileRoute('/test/funformmodal')({
  component: RouteComponent,
})

function RouteComponent() {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const bodyComponentRef = useRef<BodyComponentHandle>(null)

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 dark:bg-mist-950 p-4">
      <button
        onClick={() => setIsModalOpen(true)}
        className="rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800"
      >
        Open Example Modal
      </button>

      <SimpleModalDialog
        open={isModalOpen}
        onClose={(buttonId) => {
          console.log('Dialog closed with button:', buttonId)
          setIsModalOpen(false)
        }}
        dialogTitle="Interactive Button Handler Test"
        icon={faClock}
        iconColor="blue"
        BodyComponent={ExampleBodyComponentWithButtonHandler}
        data={{}}
        bodyComponentRef={bodyComponentRef}
        buttons={[
          {
            id: 'dont-close',
            label: 'Dont Close',
            color: 'secondary',
            faIcon: faClock,
          },
          {
            id: 'close-in-1-second',
            label: 'Close in 1 second',
            color: 'primary',
            faIcon: faCheckCircle,
          },
        ]}
      />
    </div>
  )
}
